import React, { useEffect, memo } from 'react';
import { useIntl } from 'react-intl';
import { ButtonProps, Theme, Snackbar } from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { LabelPlacement, AlertTypes } from '../types';

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      width: '100%',
      borderWidth: 1,
      borderStyle: 'solid',
      marginTop: 10,
      '& .MuiSvgIcon-root': {
        width: '18.33px',
        height: '18.33px',
      },
      '& .MuiAlert-action': {
        alignItems: 'flex-start',
      },
      '& .MuiAlert-message': {
        textAlign: 'left',
      },
    },
  });
};

export interface AlertComponentProps
  extends WithStyles<ButtonProps & typeof styles> {
  labelPlacement?: LabelPlacement;
  id: string;
  children: string;
  type: AlertTypes;
  isOpen: boolean;
  handleClose: () => void;
}

export const AlertComponent: React.FC<AlertComponentProps> = ({
  classes,
  id,
  children = 'Sample massege',
  type = 'error',
  isOpen,
  handleClose,
}: AlertComponentProps) => {
  const intl = useIntl();
  useEffect(() => {
    const timeId = setTimeout(() => {
      handleClose();
    }, 6000); // 6 sec

    return () => {
      clearTimeout(timeId);
    };
  }, []);

  return (
    <Snackbar
      open={isOpen}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        severity={type}
        className={classes.root}
        id={id}
        // variant="filled"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => handleClose()}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {intl.formatMessage({
          id: children,
        })}
      </Alert>
    </Snackbar>
  );
};

export default memo(withStyles(styles)(AlertComponent));
